"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { buildLogContext } from '../lib';
export const augmentAgent = agent => {
  const loggingContext = buildLogContext();
  for (const key of Object.keys(loggingContext)) {
    agent.setCustomAttribute(key, loggingContext[key] || 'NA');
  }
  return agent;
};